function normalizeText(text) {
  return (text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function normalizeRoleSlugs(value) {
  if (Array.isArray(value)) {
    return value.join(',')
  }

  return String(value || '')
}

function buildMemberMarkup(item, icons) {
  const name = escapeHtml(item.name || '')
  const rol = escapeHtml(item.rol || '')
  const roleSlug = escapeHtml(normalizeRoleSlugs(item.rol_slug))
  const photo = escapeHtml(item?.photo?.url || '')
  const arrowIcon = escapeHtml(icons.arrow || '')

  return `
    <article class="row-doc miembro" data-rol="${roleSlug}" data-photo="${photo}" role="listitem" itemscope itemtype="https://schema.org/Person">
      <span class="font-semibold" itemprop="name">${name}</span>
      <span class="rol" itemprop="jobTitle">${rol}</span>
      ${photo ? `<meta itemprop="image" content="${photo}">` : ''}
      <span class="open" aria-hidden="true">
        <img src="${arrowIcon}" alt="" loading="lazy" decoding="async" />
      </span>
    </article>
  `
}

function initMembersFilterSystem() {
  const list = document.querySelector('.miembros-list')
  const filterRoot = document.getElementById('rol-filter')
  const searchInput = document.getElementById('search')
  const searchButton = document.getElementById('search-button')
  const trigger = document.getElementById('rol-filter-trigger')
  const label = document.getElementById('rol-filter-label')
  const menu = document.getElementById('rol-filter-menu')
  const sentinel = document.getElementById('miembros-load-sentinel')
  const resultsCount = document.querySelector('.miembros-show-count')
  const photoPreview = document.querySelector('img#photo')

  if (!list || !filterRoot || !searchInput || !trigger || !menu) {
    return
  }

  const endpoint = list.dataset.endpoint || ''
  if (!endpoint) {
    return
  }

  const isInitialized = filterRoot.dataset.initialized === 'true'

  const state = filterRoot.__membersFilterState || {
    searchTerm: '',
    role: '*',
    page: parseInt(list.dataset.currentPage || '1', 10) || 1,
    perPage: parseInt(list.dataset.perPage || '20', 10) || 20,
    totalItems: parseInt(list.dataset.totalItems || '0', 10) || 0,
    hasMore: list.dataset.hasMore === '1',
    isLoading: false,
    searchTimeout: null,
    requestToken: 0,
    observer: null
  }
  filterRoot.__membersFilterState = state

  const icons = {
    arrow: list.dataset.arrowIcon || ''
  }

  const getNoResultsNode = () => {
    let node = document.getElementById('no-results-message')
    if (!node) {
      node = document.createElement('div')
      node.id = 'no-results-message'
      node.className = 'hidden pt-8 pb-20 opacity-60'
      node.textContent = 'No se encontraron miembros con los filtros actuales.'
      const list = document.querySelector('.miembros-list')
      list?.insertAdjacentElement('afterend', node)
    }
    return node
  }

  const getMembers = () => Array.from(list.querySelectorAll('.miembro'))

  const updateResultsCount = () => {
    if (!resultsCount) return

    const visibleCount = getMembers().length
    resultsCount.textContent = String(visibleCount)
  }

  const updateActiveOption = () => {
    const options = menu ? Array.from(menu.querySelectorAll('.rol-option')) : []
    options.forEach((option) => {
      const isActive = option.dataset.value === state.role
      option.classList.toggle('opacity-100', isActive)
      option.classList.toggle('opacity-80', !isActive)
    })
  }

  const updateNoResults = () => {
    const visibleCount = getMembers().length
    const noResults = getNoResultsNode()
    noResults.classList.toggle('hidden', visibleCount !== 0 || state.isLoading)
    updateResultsCount()
  }

  const setLoading = (value) => {
    state.isLoading = value
    list.dataset.loading = value ? '1' : '0'
  }

  const renderMembers = (items, { append = false } = {}) => {
    if (!append) {
      list.innerHTML = ''
    }

    if (!items.length) {
      updateNoResults()
      return
    }

    const html = items.map((item) => buildMemberMarkup(item, icons)).join('')
    list.insertAdjacentHTML('beforeend', html)
    updateNoResults()
  }

  const rebuildRoleOptions = (rolesMap) => {
    if (!rolesMap || typeof rolesMap !== 'object') return

    const entries = Object.entries(rolesMap)
    const optionsHtml = [
      '<button type="button" class="rol-option w-full text-left pt-2 pr-2 pb-2 hover:text-red transition-color" data-value="*">Todos los roles</button>'
    ]

    entries.forEach(([slug, role], index) => {
      const borderClass = index !== entries.length - 1 ? ' border-b border-black' : ''
      optionsHtml.push(
        `<button type="button" class="rol-option w-full text-left pt-2 pr-2 pb-2 cursor-pointer hover:text-red transition-color${borderClass}" data-value="${escapeHtml(slug)}">${escapeHtml(role)}</button>`
      )
    })

    menu.innerHTML = optionsHtml.join('')
    updateActiveOption()
  }

  const fetchMembers = async ({ reset = false } = {}) => {
    if (state.isLoading) return
    if (!reset && !state.hasMore) return

    const nextPage = reset ? 1 : state.page + 1
    const params = new URLSearchParams({
      page: String(nextPage),
      per_page: String(state.perPage)
    })

    if (reset) {
      params.set('include_roles', '1')
    }

    const normalizedSearch = normalizeText(state.searchTerm)
    if (normalizedSearch) {
      params.set('search', state.searchTerm)
    }
    if (state.role && state.role !== '*') {
      params.set('role', state.role)
    }

    state.requestToken += 1
    const currentToken = state.requestToken
    setLoading(true)

    try {
      const response = await fetch(`${endpoint}?${params.toString()}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      })

      if (!response.ok) {
        throw new Error('No se pudo cargar socios')
      }

      const data = await response.json()

      if (currentToken !== state.requestToken) {
        return
      }

      const items = Array.isArray(data.items) ? data.items : []
      renderMembers(items, { append: !reset })

      if (reset) {
        rebuildRoleOptions(data.roles)
      }

      state.page = data?.pagination?.page || nextPage
      state.totalItems = parseInt(data?.pagination?.total_items || '0', 10) || 0
      state.hasMore = Boolean(data?.pagination?.has_more)
      list.dataset.currentPage = String(state.page)
      list.dataset.totalItems = String(state.totalItems)
      list.dataset.hasMore = state.hasMore ? '1' : '0'
    } catch (error) {
      if (reset) {
        renderMembers([], { append: false })
      }
    } finally {
      setLoading(false)
      updateNoResults()
    }
  }

  const openMenu = () => {
    menu.classList.remove('hidden')
    trigger.setAttribute('aria-expanded', 'true')
  }

  const closeMenu = () => {
    menu.classList.add('hidden')
    trigger.setAttribute('aria-expanded', 'false')
  }

  const toggleMenu = () => {
    if (menu.classList.contains('hidden')) {
      openMenu()
    } else {
      closeMenu()
    }
  }

  const runRemoteSearch = () => {
    fetchMembers({ reset: true })
  }

  if (!isInitialized) {
    trigger.addEventListener('click', toggleMenu)

    menu.addEventListener('click', (event) => {
      const option = event.target.closest('.rol-option')
      if (!option) return

      state.role = option.dataset.value || '*'
      label.textContent = option.textContent.trim()
      updateActiveOption()
      closeMenu()
      runRemoteSearch()
    })

    if (!window.__membersFilterOutsideClickBound) {
      document.addEventListener('click', (event) => {
        if (!filterRoot.contains(event.target)) {
          closeMenu()
        }
      })
      window.__membersFilterOutsideClickBound = true
    }

    if (!window.__membersFilterKeydownBound) {
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeMenu()
        }
        if (event.key === 'Enter' && document.activeElement === searchInput) {
          event.preventDefault()
          state.searchTerm = searchInput.value.trim()
          runRemoteSearch()
        }
      })
      window.__membersFilterKeydownBound = true
    }

    searchInput.addEventListener('input', (event) => {
      clearTimeout(state.searchTimeout)
      state.searchTimeout = setTimeout(() => {
        state.searchTerm = event.target.value.trim()
        runRemoteSearch()
      }, 250)
    })

    searchButton?.addEventListener('click', () => {
      state.searchTerm = searchInput.value.trim()
      runRemoteSearch()
    })

    if (photoPreview) {
      list.addEventListener('mouseover', (event) => {
        const member = event.target.closest('.miembro')
        if (!member) return

        const photo = member.getAttribute('data-photo') || ''
        if (!photo) return

        photoPreview.setAttribute('src', photo)
        photoPreview.style.opacity = '1'
      })

      list.addEventListener('mouseout', (event) => {
        const member = event.target.closest('.miembro')
        if (!member) return
        const related = event.relatedTarget
        if (related && member.contains(related)) {
          return
        }

        if (photoPreview) {
          photoPreview.style.removeProperty('opacity')
        }
      })
    }

    if (sentinel && typeof window.IntersectionObserver !== 'undefined') {
      state.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            fetchMembers({ reset: false })
          }
        })
      }, {
        rootMargin: '200px 0px'
      })

      state.observer.observe(sentinel)
    }

    filterRoot.dataset.initialized = 'true'
  }

  searchInput.value = state.searchTerm
  const options = menu ? Array.from(menu.querySelectorAll('.rol-option')) : []
  const currentOption = options.find((option) => option.dataset.value === state.role)
  if (currentOption) {
    label.textContent = currentOption.textContent.trim()
  }

  updateActiveOption()
  updateNoResults()
}

function searchFilterMiembros() {
  initMembersFilterSystem()
}

export default searchFilterMiembros
